<template>
    <v-app-bar app color="primary" clipped-left dark>
        <span class="mx-2">{{name}}</span><v-divider vertical class="mx-2"></v-divider>
        <span>{{label}}</span>
        <v-spacer></v-spacer>
        <v-divider vertical class="mx-2"></v-divider>
        <v-btn class="mx-2" text fab small @click.stop="showHelp()">
            <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn>
        <v-divider vertical class="mx-2"></v-divider>
    </v-app-bar>
</template>

<script>
import HelpDialog from "@/support/helpMessage";
const siteconfig = require("@/support/siteconfig")
export default {
    data: () => ({ name: siteconfig.name, label: siteconfig.label }),
    methods: {
        async showHelp() {
            const aMessage = HelpDialog.GetHelpMessage(siteconfig.sitename);
            await this.$root.$confirmdialog("About - " + siteconfig.name, aMessage, {
                color: "secondary",
                reject: "",
                accept: "Okay",
            });
        },
    },
};
</script>